module.exports = __webpack_public_path__ + "static/1_1_example-2_SE-396cbbed75cd66b728fba30446acf1ed.svg";